import _ from 'lodash';
import React from 'react';
import Modal from 'react-bootstrap/Modal';

import { clickToShare, socialMedia } from '../../../../../shared/click-to-share';
import copyToClipboard from '../../../../../shared/copy-to-clipboard';

export default class PublishPromptToShareModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      show: false,
      email: null,
      url: null,
      wirePath: null,
      wireId: null,
      published: false,
      approvalStatus: null,
    };

    this.dismiss = this.dismiss.bind(this);
    this.present = this.present.bind(this);
    this.getSuccessMessage = this.getSuccessMessage.bind(this);
  }

  getSuccessMessage() {
    if (this.state.published) {
      return 'Your wire has been published and is now live!';
    }
    if (this.state.approvalStatus === 'pending_approval') {
      return 'Your wire has been submitted for review. An editor will review and publish it once approved.';
    }
    return 'Your wire has been saved successfully.';
  }

  present(d) {
    const state = {
      ...d.data.shares,
      url: d.data.url,
      wirePath: d.data.wire_path,
      wireId: d.data.wireId,
      published: d.data.published || false,
      approvalStatus: d.data.approval_status || null,
      show: true,
    };
    this.setState(state);
  }

  dismiss() {
    this.setState({ show: false }, () => (window.location = this.state.wirePath));
  }

  render() {
    return (
      <Modal
        centered="true"
        dialogAs="article"
        dialogClassName={`horizontal${!this.state.published ? ' compact' : ''}`}
        show={this.state.show}
        backdrop="static"
      >
        <Modal.Body as="section" className="top">
          <span>
            <svg className="icon"><use href="#success" /></svg>
          </span>
          <strong>success</strong>
          <p>
            {this.getSuccessMessage()}
          </p>
        </Modal.Body>
        {this.state.published && (
          <Modal.Footer as="section" className="bottom">
            <strong className="title">get more views</strong>
            <p className="main">Drive more traffic to your wires by sharing to your other channels.</p>
            <div className="flex-box-row">
              <a className="link-secondary" href={this.state.email} target="_self">
                <span className="icon-lw icon-lw-email" />
              </a>
              {_.map(socialMedia, _.toLower).map(d => (
                <a
                  href="#"
                  key={d}
                  className="link-secondary"
                  onClick={() => clickToShare({ wireId: this.state.wireId, source: d, medium: 'publisher-prompt' })}
                >
                  <span className={`icon-lw icon-lw-${d}`} />
                </a>
              ))}
              <div className="full-row">
                <input className="url" type="text" readOnly value={this.state.url || ''} />
                <button type="button" onClick={() => copyToClipboard(this.state.url)}>
                  copy
                </button>
              </div>
            </div>
            <div className="flex-box-column">
              <button type="button" className="btn btn-primary" onClick={this.dismiss}>
                thanks, take me to my wire
              </button>
              <a href="https://livewiremarkets1.typeform.com/to/VVssyp" target="_blank" rel="noopener noreferrer" className="feedback">Provide feedback</a>
            </div>
          </Modal.Footer>
        )}
        {!this.state.published && (
          <Modal.Footer as="section" className="bottom compact">
            <div className="flex-box-column">
              <button type="button" className="btn btn-primary" onClick={this.dismiss}>
                take me to my wire
              </button>
              <a href="https://livewiremarkets1.typeform.com/to/VVssyp" target="_blank" rel="noopener noreferrer" className="feedback">Provide feedback</a>
            </div>
          </Modal.Footer>
        )}
      </Modal>
    );
  }
}
